import { useAuth } from 'react-oidc-context';

const Main = () => {
  return <>X</>;
};

export default Main;
